<template>
    <div>
        <div class="searchList">
            <a-select class="slt" ref="zymc" default-value="" v-model="queryParams.zymc" allowClear>
                <a-select-option v-for="item in zy" :key="item.id" :value="item.zymc">
                    {{ item.zymc }}
                </a-select-option>
            </a-select>
            <span class="fun-search-form-buttons" :style="{ overflow: 'hidden' }">
                <a-button class="searchBtn" type="primary" @click="loadData">搜索</a-button>
            </span>
        </div>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <!-- 表格 -->
                <vxe-table
                    ref="itemtable"
                    size="mini"
                    resizable
                    keep-source
                    auto-resize
                    row-id="id"
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(1)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    :edit-config="{
                        trigger: 'click',
                        mode: 'row',
                        showStatus: true,
                        showIcon: false
                    }"
                >
                    <vxe-table-column field="zjxm" title="专家姓名" width="150"> </vxe-table-column>
                    <vxe-table-column field="zymc" title="专业一" min-width="200"> </vxe-table-column>
                    <vxe-table-column field="zzymc" title="子专业一" min-width="150"> </vxe-table-column>
                    <vxe-table-column field="zymc1" title="专业二" min-width="200"> </vxe-table-column>
                    <vxe-table-column field="zzymc1" title="子专业二" min-width="150"> </vxe-table-column>
                    <vxe-table-column field="zc" title="职称" width="320" align="center"> </vxe-table-column>
                    <vxe-table-column title="操作" width="220" align="center">
                        <template v-slot="scope">
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top: 5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "List",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: {},
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "RKRQ",
                order: "desc"
            },
            tableDataLoading: false,
            zy: []
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        loginType: {
            get() {
                return this.getUserInfo.loginType;
            }
        }
    },
    mounted() {
        this.loadZy();
        this.loadData();
    },
    methods: {
        loadZy() {
            this.$FG_http
                .post(
                    "./api/jsaec/zjkzjcx/loadZy",
                    {},
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.zy = data.data;
                    } else {
                        // 数据加载失败清空表格
                        this.zy = [];
                    }
                });
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.itemtable.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.queryParams.loginType = this.loginType;
            this.$FG_http
                .post(
                    "./api/jsaec/zjkzjcx/list",
                    {
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.itemtable.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.itemtable.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.itemtable.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.itemtable.clearCurrentRow();
                        }
                    });
                });
        },
        view(row) {
            if (this.loginType === "会员") {
                // 转到详情页
                this.$router.push({ name: "jsaecHyXQ", params: { id: row.id, loginType: "会员" } });
            } else if (this.loginType === "非会员") {
                // 转到详情页
                this.$router.push({ name: "jsaecFhyXQ", params: { id: row.id, loginType: "非会员" } });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.searchList {
    width: 100%;
    height: 440px;
    margin: 0;
    padding: 0;
    background-image: url("../../../../assets/images/head_logo_search_zj.png");
    background-repeat: no-repeat;
    background-position: 0px 0px;
    background-size: cover;
    .slt {
        width: 450px;
        margin-top: 220px;
        margin-left: 260px;
    }
}
.searchBtn {
    margin-left: 5px;
    border-color: rgb(32, 129, 209);
    border-width: 1px;
}
</style>
